import React from "react";
import { useDroppable } from "@dnd-kit/core";

export default function ProjectRootDropZone({ isDraggingItem }) {
  const { setNodeRef, isOver } = useDroppable({
    id: "drop-root",
    data: { kind: "root" },
  });
  const highlight = isDraggingItem && isOver;
  return (
    <div
      ref={setNodeRef}
      className="mb-2 p-2 small border rounded text-muted"
      style={{
        borderStyle: "dashed",
        borderColor: highlight ? "#0d6efd" : "#ced4da",
        backgroundColor: highlight ? "#eef5ff" : "transparent",
        transition: "all 120ms ease",
      }}
    >
      Drop here to move item to root level
    </div>
  );
}
